import { render, staticRenderFns } from "./usercoin.vue?vue&type=template&id=b04d548e&scoped=true"
import script from "./usercoin.vue?vue&type=script&lang=js"
export * from "./usercoin.vue?vue&type=script&lang=js"
import style0 from "./usercoin.vue?vue&type=style&index=0&id=b04d548e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04d548e",
  null
  
)

export default component.exports